import React, { Fragment, ReactNode } from "react";
import { AppState } from "../../store";
import { SystemState } from "../../store/system/types";
import { connect } from "react-redux";
import { Helmet } from "react-helmet";

interface TenantHelmetConfig {
  favicon: string;
  description: string;
  title: string;
  themeColor: string;
}

const allowedscripts: ReactNode[] = [];

const helmetByTenant: Record<string, TenantHelmetConfig> = {
  TBC: {
    favicon: "/favicon/faviconTBC.ico",
    description: "The Blue Coding - Gestion de clientes, pagos y renovaciones.",
    title: "The Blue Coding",
    themeColor: "#2177f5",
  },
  EF: {
    favicon: "/favicon/faviconEF.ico",
    description: "Expo Flores",
    title: "Expo Flores",
    themeColor: "#387f44",
  },
};

const getHelmetConfig = (): TenantHelmetConfig => {
  const tenant = (process.env.REACT_APP_CODE_TENANT || "TBC").trim().toUpperCase();
  return helmetByTenant[tenant] || helmetByTenant.TBC;
};

const HelmetIndex: React.FC<SystemState> = (props: SystemState) => {
  const config = getHelmetConfig();

  return (
    <Fragment>
      <Helmet>
        <html lang="es" />
        <title>{config.title}</title>
        <link rel="icon" href={config.favicon} type="image/x-icon" />
        <link rel="shortcut icon" href={config.favicon} type="image/x-icon" />
        <meta name="description" content={config.description} />
        <meta name="theme-color" content={config.themeColor} />
        {allowedscripts.map((item) => item)}
      </Helmet>
    </Fragment>
  );
};

const mapStateToProps = (state: AppState) => ({
  ...state.system,
});

export default connect(mapStateToProps)(HelmetIndex);
